var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popover',{attrs:{"trigger":"hover","width":"200"}},[_vm._l((_vm.dataSource),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"desc-title"},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")]),_c('div',{staticClass:"desc-content",domProps:{"innerHTML":_vm._s(item.content)}})])}),_vm._t("default",null,{"slot":"reference"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }